import { PageHeader } from '@celltrak/ui-components';

const ExceptionHeader = () => (
  <header>
    <PageHeader title="Exception Codes" />
  </header>
);

export default ExceptionHeader;
